import React from 'react';
import {PropTypes} from 'prop-types';
import DirectNavigationModel from '../DirectNavigationModel';
import './WebMenu.less';
import DropdownMenu from '../DropdownMenu/DropdownMenu.react';
import LocaleContext from '../../../../../Contexts/Locale/Context';
import NavigationView from '../NavigationView/NavigationView.react';
import {ButtonIcon} from '@homeaway/react-buttons';
import {EXPAND__24, MINIMIZE__24} from '@homeaway/svg-defs';
import withLog from '../../../hoc/WithLog.react';
import LogPropTypes from '../../../../../Contexts/Logging/PropTypes';
import withLifecycleLogging from '../../../hoc/WithLifecycleLogging.react';

class WebMenu extends React.Component {
    constructor(props) {
        super(props);
        let shouldUseDirectNav = !!(props.navigation.groups || props.navigation.structure);
        this.state = {
            labelKey: '',
            docked: shouldUseDirectNav,
            directNavAvailable: shouldUseDirectNav,
            hotspotsHidden: props.hotspotsHidden,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {label, ...rest} = prevState;
        const {labelKey, labelTable} = DirectNavigationModel.getLabelKeyAndTable(
            nextProps.navigation,
            nextProps.sphereId
        );
        let shouldUseDirectNav = !!(nextProps.navigation.groups || nextProps.navigation.structure);
        return {
            ...rest,
            labelKey,
            labelTable,
            directNavAvailable: shouldUseDirectNav,
            docked: shouldUseDirectNav && (prevState.docked || !prevState.directNavAvailable),
        };
    }

    handleSpaceSelected = (sphereId) => {
        if (this.props.onSelectNavSpace) {
            this.props.onSelectNavSpace(sphereId);
        }
        document.activeElement.blur();
    };

    _onToggleClick = () => {
        this.setState({
            docked: !this.state.docked,
        });
        this.props.log.info('WebMenu.onToggleClick', {props: this.props, state: this.state});
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.docked !== this.state.docked) {
            let resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        }
    }

    _renderMenu(getTranslation) {
        const headerLabel = getTranslation('messages', 'directNav.exploreThisHome');
        if (this.state.docked) {
            return (
                <div className={'dock'}>
                    <h3 className={`dockedLabel`}>{headerLabel}</h3>
                    <NavigationView
                        disabled={false}
                        navigation={this.props.navigation}
                        sphereId={this.props.sphereId}
                        onSelectNavSpace={(sphereId) => this.handleSpaceSelected(sphereId)}
                        useMediaGateway={this.props.useMediaGateway}
                    />
                </div>
            );
            // Direct nav is available, but menu is not docked
        } else if (this.state.directNavAvailable) {
            return (
                <div className={'dropdownWrapper'}>
                    <h3 className={`dropdownLabel`}>{headerLabel}</h3>
                    <DropdownMenu
                        navigation={this.props.navigation}
                        sphereId={this.props.sphereId}
                        onSelectNavSpace={this.handleSpaceSelected}
                        onOpen={this.props.onOpen}
                        onClose={this.props.onClose}
                        useMediaGateway={this.props.useMediaGateway}
                        label={
                            <span>
                                {getTranslation(this.state.labelTable, this.state.labelKey)}
                            </span>
                        }
                    />
                </div>
            );
        }

        return (
            <div className={'persistentMenu'}>
                <h4 className={`persistentMenuLabel`}>{headerLabel}</h4>
                <NavigationView
                    disabled={false}
                    navigation={this.props.navigation}
                    sphereId={this.props.sphereId}
                    onSelectNavSpace={(sphereId) => this.handleSpaceSelected(sphereId)}
                    useMediaGateway={this.props.useMediaGateway}
                />
            </div>
        );
    }

    render() {
        /* todo: Fix text wrap and spacing for long text, such as an unfound translation*/
        /*
         * todo: fix all of they dynamically generated objects in render functions that
         * are forcing excess updates.
         */
        return (
            <div className={`WebMenu ${this.state.docked ? 'Docked' : 'Float'}`}>
                <LocaleContext.Consumer>
                    {(getTranslation) => {
                        return this._renderMenu(getTranslation);
                    }}
                </LocaleContext.Consumer>
                {this.state.directNavAvailable && !this.state.hotspotsHidden ? (
                    <div className={'toggleWrapper'}>
                        <ButtonIcon
                            label={'Dock Menu'}
                            svgMarkup={this.state.docked ? MINIMIZE__24 : EXPAND__24}
                            circle
                            onClick={this._onToggleClick}
                            size={'sm'}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

WebMenu.propTypes = {
    navigation: DirectNavigationModel.navigationType.isRequired,
    sphereId: PropTypes.string.isRequired,
    onSelectNavSpace: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    log: PropTypes.shape(LogPropTypes).isRequired,
    hotspotsHidden: PropTypes.bool,
    useMediaGateway: PropTypes.bool,
};

WebMenu.defaultProps = {
    className: 'WebMenu',
};

export default withLog(withLifecycleLogging(WebMenu));
